import { UsersIcon } from 'lucide-react';
import { useState } from 'react';

import { cn } from '@/lib/utils';
import { IntranetChannelSheet } from '@/products/intranet/components/intranet-channel-sheet';
import { useIntranetChannelNav } from '@/products/intranet/features/intranet/use-intranet-channel-nav';

const tabClass =
  'flex h-16 min-w-0 w-full flex-col items-center justify-center gap-0.5 px-2 text-xs text-muted-foreground';

/** Bottom-nav Channels control; reuses the existing channel sheet. */
export function IntranetChannelsTab() {
  const [open, setOpen] = useState(false);
  const channelNav = useIntranetChannelNav();

  return (
    <>
      <button
        type="button"
        className={cn(tabClass, open && 'font-medium text-primary')}
        aria-label="Channels"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <UsersIcon className="size-5" aria-hidden />
        <span className="max-w-full truncate">Channels</span>
      </button>
      <IntranetChannelSheet open={open} onOpenChange={setOpen} {...channelNav} />
    </>
  );
}
